import { GxButton } from '@garpix/garpix-web-components-react';
import React, { FC, useState } from 'react';
import styles from './styles/index.module.scss';

interface IInputUploadFile {
    label?: string,
    name: string,
    setFieldValue?: (name: string, e: any) => void,
}

const InputUploadFile: FC<IInputUploadFile> = (
    {
        label,
        name,
        setFieldValue
    }) => {
    const [fileName, setFileName] = useState('');

    const handleChange = (e: any) => {
        const file = e.currentTarget.files[0];
        if (setFieldValue && name) {
            setFileName(file.name);
            setFieldValue(name, e.currentTarget.files[0])
        }
    }

    const handleRemove = () => {
        setFileName('');
        if (setFieldValue && name) {
            setFieldValue(name, '')
        }
    }

    return (
        <div className={styles['actions-file']}>
            {label && <span className={styles['actions-file--title']} >{label}</span>}
            {fileName ?
                <div className={styles['actions-file--remove']}>
                    <span className={styles['actions-file--file-name']}>{fileName}</span>
                    <GxButton className={styles['actions-file--btn_remove']} onClick={handleRemove} />
                </div>
                :
                <GxButton className={styles['actions-file--btn']} type='button'>
                    <label className={styles['actions-file--upload']} htmlFor={name}>
                        <span>Загрузить</span>
                        <input
                            name={name}
                            onChange={handleChange}
                            type='file'
                            id={name}
                        />
                    </label>
                </GxButton>
            }
        </div>
    )
}

export default InputUploadFile;